const ResetStandardFactory = () => {
  return (
    <>
      <section id="reset-padrao-fabrica" className="content-section">
        <div className="card mb-3">
          <div className="card-body text-center">
            <h5 className="card-title">Reset (padrão de fábrica)</h5>
          </div>

          <div className="card-body">
            <div className="card">
              <div className="card-body">
                <p className="mb-0">
                  Há dois modos de redefinir as configurações:
                </p>

                <ul className="p-xss-0 p-md-3 justified-text">
                  <li>
                    <p className="justified-text">
                      <strong>Botão reset físico: </strong>Mantenha pressionado o botão Reset por
                      aproximadamente 10 segundos. Solte-o e aguarde o equipamento reiniciar. O botão comumente se encontra
                      na parte inferior traseira do equipamento.
                    </p>
                  </li>
                  <div className="d-flex justify-content-center print-image img-container">
                    <img src="./res/figures/reset-rapido.png" className="card-img-bottom img-lg" id="reset-rapido" alt="" />
                  </div>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Reset via software: </strong>use o botão Restaurar padrão de fábrica disponível na guia
                      Sistema<strong>&gt;&gt;</strong>Configurações<strong>&gt;&gt;</strong>Configuração padrão de fábrica,
                      na interface de gerenciamento web do produto.
                    </p>
                  </li>
                </ul>
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/reset-fabrica.png" className="card-img-bottom img-md" alt="" />
                </div>
                <p className="mb-0 justified-text">
                  <strong>Obs.: </strong>não desligue o equipamento durante esse processo.
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default ResetStandardFactory;
